import styled from 'styled-components';
import { shade } from 'polished';

export const Container = styled.section`
  height: 25px;
  width: 25px;
  position: sticky;
  margin-top: 100%;
  bottom: 5px;
  left: 50%;
  z-index: 200;
  color: #21c25e;
`;

export const BodyChat = styled.section`
  position: fixed;
  background-color: #fff;
  border-radius: 10px;
  z-index: 200;
  bottom: -60px;
  width: 240px;
  left: 0px;
  animation-name: ${(props) => (props.sizeChat ? 'fadeInLeft' : '')};
  animation-duration: 0.3s;

  .icon-internal-chat {
    transition: ease-in-out 0.3s;
  }

  .icon-internal-chat:hover {
    color: ${shade(0.2, '#21c25e')};
    transform: scale(1.3, 1.3);
  }

  @keyframes fadeInLeft {
    0% {
      width: 0px;
      opacity: 0;
    }
    100% {
      opacity: 1;
      width: 249px;
    }
  }
`;

export const ContainerChat = styled.section`
  overflow-y: scroll;
  scroll-behavior: smooth;
  height: ${(props) => (props.sizeChat ? '280px' : '0px')};
  transition: ease-in-out 0.4s;
  background: #fff;
  border-radius: 10px 10px 0 0;

  &::-webkit-scrollbar {
    width: 0;
  }
`;

export const Header = styled.header`
  /* min-height: 40px; */
  background-color: ${(props) => (props.color ? props.color : 'gray')};
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 10px 10px 0 0;
  padding: 8px;
  color: ${(props) => (props.fontColor ? props.fontColor : '#000')};
`;

export const UserList = styled.div`
  width: 100%;
  display: flex;
  position: relative;
  align-items: center;
  padding: 8px 10px;
  transition: background-color 0.2s ease-in-out;
  border-bottom: 1px solid #f0f0f0;

  .name-user-chat-internal {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    font-family: 'Roboto', sans-serif;
    color: #383838;
    margin-right: auto;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    font-weight: 500;
    cursor: pointer;
  }

  .lastMessage {
    font-size: 12px;
    color: #808080;
    margin: 0;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    max-width: 150px; /* Adjust as needed */
    cursor: pointer;
  }

  .title_internal_chat {
    margin: 0;
    cursor: pointer;
  }

  cursor: pointer;
  &:hover {
    background-color: #f5f5f5;
  }
`;
export const GroupList = styled.div`
  height: 45px;
  width: 100%;
  display: flex;
  justify-content: space-around;
  margin-top: 3px;
  align-items: center;
  transition: ease-in-out 0.3s;

  .name-group-chat-internal {
    font-family: 'Roboto', sans-serif;
    color: #383838;
    margin-right: auto;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  cursor: pointer;
  &&:hover {
    -webkit-box-shadow: 0px 1px 13px -1px rgba(0, 0, 0, 0.24);
    box-shadow: 0px 1px 13px -1px rgba(0, 0, 0, 0.24);
  }
`;

export const ProfileInternalChat = styled.div`
  height: 38px;
  width: 38px;
  min-width: 38px;
  border-radius: 50%;
  background-color: white;
  background-image: url(${(props) => props.src});
  background-repeat: no-repeat;
  background-size: cover;
`;

export const AvatarWrapper = styled.div`
  position: relative;
  display: inline-flex;
  margin: 0 15px 0 10px;
`;

export const StatusIndicator = styled.span`
  position: absolute;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: ${(props) => props.color};
  border: 2px solid #fff;
  right: -2px;
  bottom: -2px;
`;

export const ContentDate = styled.div`
  height: 38px;
  width: 43px;
  min-width: 43px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: flex-end;
  margin-right: 8px;

  .hours-message-internal-chat {
    font-family: 'Roboto', sans-serif;
    font-size: 10px;
    font-weight: bold;
    color: #383838;
  }

  .qauntity-message-internal-chat {
    display: flex;
    font-family: 'Roboto', sans-serif;
    justify-content: center;
    align-items: center;
    color: #fff;
    height: 15px;
    background-color: #ca7272;
    font-size: 10px;
    width: 15px;
    border-radius: 50%;
    min-width: 15px;
  }
`;
export const ButtonAddGroup = styled.span`
  width: 8px;
  height: 8px;
  background-color: #47aa4e;
  border: transparent;
  border-radius: 50%;

  position: absolute;
  left: 46px;
  margin-top: 22px;
`;
export const Sinalization = styled.span`
  width: 12px;
  height: 12px;
  background-color: ${(props) => props.color};
  border: transparent;
  border-radius: 50%;
  margin-right: 0.5rem;
`;
export const HeaderGroup = styled.div`
  width: 100%;
  height: 36px;
  background-color: ${(props) => props.src};
  color: ${(props) => props.srcColor};
  font-size: 12;
  display: flex;
  flex-direction: row;
  padding-left: 0.5rem;
  padding-top: 0.5rem;

  p {
    margin-left: 0.5rem;
    margin-top: -0.2rem;
    cursor: default;
  }
`;
export const MainGroup = styled.div`
  width: 100%;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.3rem;

  & > div {
    margin-bottom: 0.5rem;
    cursor: default;
    color: black;
  }
`;
export const CreateGroup = styled.div`
  width: 100%;
  padding: 15px;
  display: flex;
  justify-content: center;
  align-items: center;

  label {
    width: 80px;
    height: 80px;
    border-radius: 100%;
    background-color: white;
    border: 5px solid ${(props) => props.children.props.bordertheme};
  }
`;
export const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  gap: 0.5rem;

  .input-name {
    margin-top: -2rem;
  }

  textarea {
    display: block;
    width: 100%;
    height: 80px;
    padding: 0.625rem 0.75rem;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;
    color: #8898aa;
    resize: none;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #dee2e6;
    border-radius: 0.25rem;
    box-shadow: 0 3px 2px rgba(233, 236, 239, 0.05);

    ::placeholder {
      font-size: 0.875rem;
      font-weight: 400;
      line-height: 1.5;
      color: #8898aa;
    }

    ::-webkit-scrollbar {
      width: 2px;
    }
    ::-webkit-scrollbar-track {
      background: #f1f1f1;
    }
    ::-webkit-scrollbar-thumb {
      background: #c1c1c1;
    }
    ::-webkit-scrollbar-thumb:hover {
      background: #555;
    }
  }
`;

export const ButtonGroup = styled.div`

  padding: 15px;
  display: flex;
  align-items: center;
  justify-content: center;

  button{
    cursor: pointer;
  width: 30px;
  height: 30px;
  border-radius: 100%;
  background-color: ${(props) => props.buttoncolor};
  border: 1px solid ${(props) => props.buttoncolor};
  transition: 0.2s;
  }

  button:hover{
    filter: brightness(80%);
  }
  ]
`;

export const WrapperHeaderButton = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 4px;
`;

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ChatToggleButton = styled.button`
  flex: 1;
  width: auto;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  background: transparent;
  border: none;
  color: white;
  padding: 0;
  cursor: pointer;
  font-family: 'Roboto', sans-serif;
  margin-left: 8px !important;
  font-size: 16px;
`;

export const StatusWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
`;

export const StatusDot = styled.span`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: ${(props) => props.color || '#9e9e9e'};
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.6);
`;

export const NotificationBadge = styled.span`
  position: absolute;
  top: -6px;
  right: -6px;
  background-color: red;
  outline: 1px solid white;
  color: white;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  font-size: 10px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
`;

export const CardNotificationBadge = styled.span`
  background-color: red;
  outline: 1px solid white;
  color: white;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  font-size: 10px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const GroupCreateButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  background: transparent;
  border: none;
  color: white;
  cursor: pointer;
  transition: transform 0.15s ease;

  &:hover {
    transform: scale(1.1);
  }
`;
export const GroupOptionsButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  background: transparent;
  border: none;
  color: #808080;
  cursor: pointer;
  border-radius: 6px;
  transition: transform 0.15s ease, background 0.15s ease;

  &:hover {
    transform: scale(1.06);
    background: rgba(0, 0, 0, 0.06);
  }
`;

export const StatusSelectorContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

export const StatusButton = styled.button`
  width: 100%;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.15);
  cursor: pointer;
  color: white;
  font-size: 13px;
  transition: background 0.15s ease, border-color 0.15s ease;

  svg {
    margin-left: auto;
  }

  &:hover {
    background: rgba(255, 255, 255, 0.25);
    border-color: rgba(255, 255, 255, 0.4);
  }
`;

export const ChevronIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s ease;
  transform: ${(props) => (props.isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
  margin-left: auto;
`;

export const StatusMenu = styled.div`
  position: absolute;
  top: 0;
  left: calc(100% + 10px);
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.08);
  z-index: 20;
  overflow: hidden;
  width: 100%;

  &::before {
    content: '';
    position: absolute;
    left: -6px;
    top: 14px;
    width: 0;
    height: 0;
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-right: 6px solid #e0e0e0;
  }

  &::after {
    content: '';
    position: absolute;
    left: -5px;
    top: 14px;
    width: 0;
    height: 0;
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent;
    border-right: 5px solid #ffffff;
  }
`;

export const StatusOption = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border: none;
  background: transparent;
  text-align: left;
  cursor: pointer;
  color: #2e2e2e;

  &:hover {
    background: #f5f5f5;
  }
`;

export const StatusOptionText = styled.span`
  display: flex;
  flex-direction: column;
  line-height: 1.2;
`;

export const StatusOptionLabel = styled.span`
  font-weight: 600;
  font-size: 14px;
`;

export const StatusOptionDescription = styled.span`
  font-size: 12px;
  color: #6c6c6c;
`;

export const GroupOptionsButtonWhite = styled.button`
 display: inline-flex;
 align-items: center;
 justify-content: center;
 width: 28px;
 height: 28px;
 background: transparent;
 border: none;
 color: white;
 cursor: pointer;
 border-radius: 6px;
 transition: transform 0.15s ease, background 0.15s ease;

 &:hover {
 transform: scale(1.06);
 background: rgba(255,255,255,0.1);
 color: white;
 }
}`;
